import type {
  FulfillmentProgress,
  WorkPackageKind,
  WorkPackagePriority,
  WorkPackageStatus,
  WorkTaskStatus,
} from "@common/client"

export const TASK_STATUSES = [
  "not_started",
  "in_progress",
  "on_hold",
  "awaiting_parts",
  "complete",
  "signed_off",
  "deferred",
  "closed",
] as const satisfies readonly WorkTaskStatus[]

export type HoldStatus = Extract<WorkTaskStatus, "on_hold" | "awaiting_parts">

export type PickableStatus = Exclude<
  WorkTaskStatus,
  "complete" | "signed_off" | "closed"
>

export function isPickable(status: WorkTaskStatus): status is PickableStatus {
  return status !== "complete" && status !== "signed_off" && status !== "closed"
}

export function isHold(status: WorkTaskStatus): status is HoldStatus {
  return status === "on_hold" || status === "awaiting_parts"
}

export function taskStatusLabel(status: WorkTaskStatus): string {
  switch (status) {
    case "not_started":
      return "Not started"
    case "in_progress":
      return "In progress"
    case "on_hold":
      return "On hold"
    case "awaiting_parts":
      return "Awaiting parts"
    case "complete":
      return "Complete"
    case "signed_off":
      return "Signed off"
    case "deferred":
      return "Deferred"
    case "closed":
      return "Closed"
  }
}

export const STATUSES = [
  "draft",
  "scheduled",
  "in_progress",
  "complete",
  "closed",
  "cancelled",
] as const satisfies readonly WorkPackageStatus[]

export function doneCount(progress: FulfillmentProgress): number {
  return progress.complete + progress.signed_off + progress.closed
}

export function statusLabel(status: WorkPackageStatus): string {
  switch (status) {
    case "draft":
      return "Draft"
    case "scheduled":
      return "Scheduled"
    case "in_progress":
      return "In progress"
    case "complete":
      return "Complete"
    case "closed":
      return "Closed"
    case "cancelled":
      return "Cancelled"
  }
}

export const PRIORITIES = [
  "aog",
  "routine",
] as const satisfies readonly WorkPackagePriority[]

export function priorityOf(workOrder: {
  aog_at?: string | null
}): WorkPackagePriority {
  return workOrder.aog_at ? "aog" : "routine"
}

export const KINDS = [
  "aircraft",
  "traveller",
] as const satisfies readonly WorkPackageKind[]

export function kindLabel(kind: WorkPackageKind): string {
  switch (kind) {
    case "aircraft":
      return "Aircraft"
    case "traveller":
      return "Component"
  }
}

export function priorityLabel(priority: WorkPackagePriority): string {
  switch (priority) {
    case "aog":
      return "AOG"
    case "routine":
      return "Routine"
  }
}
